import { memo } from 'react';
import { Text } from '@betty/moonlight';
import { InfoProps } from './Info.types';

function Info({ text, textKey, textNS }: InfoProps) {
  return (
    <Text
      variant="body-m"
      locKey={textKey}
      locNS={textNS}
      color="darkSurfacePrimary"
    >
      {text}
    </Text>
  );
}

export default memo(Info);
